import {View} from "../../../../km_app/types/View";

export const getGtmEcommerceListDetailsByViewType = (viewType: View) => {
    switch (viewType) {
        case View.FAVORITE:
            return {
                item_list_id: "kontomieszkaniowe_ulubione",
                item_list_name: "Kontomieszkaniowe - ulubione"
            };
        case View.APPLICATION_SENT:
            return {
                item_list_id: "kontomieszkaniowe_wyslane",
                item_list_name: "Kontomieszkaniowe - wysłane"
            };
        case View.DISMISSED:
            return {
                item_list_id: "kontomieszkaniowe_odrzucone",
                item_list_name: "Kontomieszkaniowe - odrzucone"
            };
        case View.MY_OFFER:
            return {
                item_list_id: "kontomieszkaniowe_lista_wszystkich_ofert",
                item_list_name: "Kontomieszkaniowe - lista wszystkich ofert"
            };
        case View.COMPARATOR:
            return {
                item_list_id: "kontomieszkaniowe_porownywarka",
                item_list_name: "Kontomieszkaniowe - porównywarka"
            };
        default:
            return {
                item_list_id: "kontomieszkaniowe",
                item_list_name: "Kontomieszkaniowe"
            };
    }
};
import {View} from "../../../../km_app/types/View";

export const getGtmEcommerceListDetailsByViewType = (viewType: View) => {
    switch (viewType) {
        case View.FAVORITE:
            return {
                item_list_id: "kontomieszkaniowe_ulubione",
                item_list_name: "Kontomieszkaniowe - ulubione"
            };
        case View.APPLICATION_SENT:
            return {
                item_list_id: "kontomieszkaniowe_wyslane",
                item_list_name: "Kontomieszkaniowe - wysłane"
            };
        case View.DISMISSED:
            return {
                item_list_id: "kontomieszkaniowe_odrzucone",
                item_list_name: "Kontomieszkaniowe - odrzucone"
            };
        case View.MY_OFFER:
            return {
                item_list_id: "kontomieszkaniowe_lista_wszystkich_ofert",
                item_list_name: "Kontomieszkaniowe - lista wszystkich ofert"
            };
        case View.COMPARATOR:
            return {
                item_list_id: "kontomieszkaniowe_porownywarka",
                item_list_name: "Kontomieszkaniowe - porównywarka"
            };
        default:
            return {
                item_list_id: "kontomieszkaniowe",
                item_list_name: "Kontomieszkaniowe"
            };
    }
};
